import candidateService from '../../services/candidateService'

const getDefaultState = () => {
  return {
    candidates: []
  }
}

const state = getDefaultState()

// const state = {
//     candidates: []
// }

const getters = {
    candidates: state => {
        return state.candidates
    }
}

const actions = {
    getCandidates ({ commit }) {
        candidateService.fetchCandidates()
        .then(candidates => {
            commit('setCandidates', candidates)
        })
    },
    addCandidate({ commit }, candidate) {
        candidateService.postCandidate(candidate).then(() => {
        commit('addCandidate', candidate)
        })
    },
    deleteCandidate( { commit }, canId) {
        candidateService.deleteCandidate(canId)
        commit('deleteCandidate', canId)
    },
    updateCandidate( { commit }, canId) {
        candidateService.deleteCandidate(canId)
        commit('deleteCandidate', canId)
    }
}

const mutations = {
    setCandidates (state, candidates) {
      state.candidates = candidates
    },
    addCandidate(state, candidate) {
      state.candidates.push(candidate)
    },
    deleteCandidate(state, canId) {
      state.candidates = state.candidates.filter(obj => obj.pk !== canId)
    }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }